import React, { useState, useEffect, useContext } from 'react'
import { Link, useNavigate} from 'react-router-dom';
import { hotelsData } from '../../../../data';
import star from '../../../../images/star.svg'
import { Container, Card, Button, Form , Col, Row, } from 'react-bootstrap';
import air from '../../../../images/air.png'
import locationGrey from '../../../../images/location-grey.png'
import AppContext from '../../../../AppContext';


const HotelSearch = () => {
  const [hotels, setHotels] = useState(hotelsData);
  const {  selectedHotelLocation } = useContext(AppContext);
  const [filteredHotels, setFilteredHotels] = useState(hotelsData);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const navigate= useNavigate()
  
  const [minAmount, setMinAmount] = useState(50000);
  const [maxAmount, setMaxAmount] = useState(500000);
  const [selectedRefundOption, setSelectedRefundOption] = useState('');
 
  const [selectedStarOption, setSelectedStarOption] = useState('all');


  useEffect(() => {
    const updatedFilterByAmount = hotelsData.filter(
      (hotel) => hotel.amount >= minAmount && hotel.amount <= maxAmount
    );
    setFilteredHotels(updatedFilterByAmount);
    setSelectedRefundOption('')
    setSelectedStarOption('')
  }, [minAmount, maxAmount]);

  const handleMinAmountChange = (e) => {
    setMinAmount(parseInt(e.target.value));
  };

  const handleMaxAmountChange = (e) => {
    setMaxAmount(parseInt(e.target.value));
  };
  const handleClearAmount = () => {
    setMinAmount(50000);
    setMaxAmount(500000);
  };
  
  const filterByCheapest = () => {
    const sortedHotels = [...hotelsData].sort((a, b) => a.amount - b.amount);
    setFilteredHotels(sortedHotels);
    setSelectedFilter('cheapest');
  };

  const filterByAll = () => {
    
    setFilteredHotels(hotelsData);
    setSelectedFilter('all');
  };

  const filterHotelsByStar = (option) => {
    setSelectedStarOption(option);

    let filteredHotels = [];

    if (option === '3 stars') {
      filteredHotels = hotels.filter((hotel) => hotel.stars === '3');
    } else if (option === '4 stars') {
      filteredHotels = hotels.filter((hotel) => hotel.stars === '4');
    } else if (option === '5 stars') {
      filteredHotels = hotels.filter((hotel) => hotel.stars === '5');
    } else {
      filteredHotels = hotels;
    }
 
    setFilteredHotels(filteredHotels);
    
    setSelectedRefundOption('')
    handleClearAmount()
  };

  const handleClear = () => {
    
    setFilteredHotels(hotelsData);
    
    setSelectedRefundOption('')
    setSelectedStarOption('')
    handleClearAmount()
  
  };


  const filterRefund = (option) => {
    setSelectedRefundOption(option);
    let filteredHotels = [];

    if (option === 'refundable') {
      filteredHotels = hotels.filter((hotel) => hotel.refundable === 'Refundable');
    } else if (option === 'nonRefundable') {
      filteredHotels = hotels.filter((hotel) => hotel.refundable === 'Non-refundable');
    } else {
      filteredHotels = hotels;
    }

    setFilteredHotels(filteredHotels);
   setSelectedStarOption('')
   handleClearAmount()
  };
  const handleSelectHotel = (hotelsId) => {
    
    navigate(`/hotel-itinerary/${hotelsId}`);
  };
  return (
    <div  className='' >
    <Card className='border-0  hotel-container d-none d-md-block'>
          <Card.Img src={air} alt='air' style={{maxHeight:'500px'}} className=''/>
        
        
        <Card.ImgOverlay  className='p-3 p-xl-5 p-lg-2 p-md-5 mt-3 mt-md-5 mx-md-4 mx-2 '>
            <div className=''>
              <div className='d-block d-md-none'>
              <div className=' text-center'>
              <Button onClick={handleClear}className=' text-white' style={{width:'200px', border: '2px solid #008080', background:'#008080'}}>Modify</Button>

              </div>
              </div>
              <div className='d-none d-md-block'>
              <div className=' text-center'>
              <Button onClick={handleClear} className=' active text-white' style={{width:'200px', border: '2px solid #008080', background:'none'}}>Modify</Button>

              </div>
              </div>
              
              <div className='mt-5'>
                <Row className=''>
                  <Col xs={12} md={12} lg={4}>
                  <div className='' style={{background:'#fafafa'}}>
                    <div className='d-flex p-3 justify-content-between align-items-center'>
                        <h5>Filter</h5>
                        <p onClick={handleClear}className='forgot-password' >Clear</p>
                        
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3'>
                      <h5>No of stars</h5>
                      <div className='d-flex gap-3 mt-1'>
                        <button className={selectedStarOption === '3 stars' ? 'active-stop' : 'stop'}
          onClick={() => filterHotelsByStar('3 stars')}>3 stars</button>
                        <button className={selectedStarOption === '4 stars' ? 'active-stop' : 'stop'}
          onClick={() => filterHotelsByStar('4 stars')}>4 stars</button>
                        <button className={selectedStarOption === '5 stars' ? 'active-stop' : 'stop'}
          onClick={() => filterHotelsByStar('5 stars')}>5 stars</button>
                      </div>
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3 '>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h5>Price</h5>
                        <p onClick={handleClearAmount}className='forgot-password' >Clear</p>
                        
                    </div>
                    <Form className='d-flex' >
         
                    <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={minAmount}
            onChange={handleMinAmountChange}
          /><Form.Label>{minAmount.toLocaleString()}</Form.Label>
        </Form.Group>
        <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={maxAmount}
            onChange={handleMaxAmountChange}
          />
          <div className='d-flex flex-row-reverse'><Form.Label > {maxAmount.toLocaleString()}</Form.Label></div>
        </Form.Group>
        </Form>
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3'>
                      <h5>Payment type</h5>
                      <div className='mt-4'>
                        <Form>
                        <Form.Group className="mb-2" controlId="formBasicCheckbox">
                        <Form.Check
      type="checkbox"
      id="refundableCheckbox"
      label="Refundable"
      checked={selectedRefundOption === 'refundable'}
        onChange={() => filterRefund('refundable')}
    
    />
    </Form.Group>
    <Form.Group className="" controlId="formBasicCheckbox">
    <Form.Check
      type="checkbox"
      id="nonRefundableCheckbox"
      label="Non-refundable"
      checked={selectedRefundOption === 'nonRefundable'}
      onChange={() => filterRefund('nonRefundable')}
    />
    </Form.Group>
                        </Form>
                      </div>
                    </div>
                   
                  </div>
                  </Col>
                  <Col>
                  <div className='mt-3 mt-lg-0'>
                  <div className='d-block d-sm-flex  p-3 gap-4 align-items-center mb-3'style={{background:'#fafafa'}}>
                        <h5 className=' mb-3 mb-sm-0'>Sort by</h5>
                        <div className='d-block d-sm-flex gap-2'>
                        <button  onClick={filterByAll}
          className={selectedFilter === 'all' ? 'active-filter' : 'filter-button'}> All</button>
                          <button  onClick={filterByCheapest}
          className={selectedFilter === 'cheapest' ? 'active-filter' : 'filter-button'}> Cheapest</button>
                    
                        </div>
                      </div>
                    <div className=''>
                        {
                          filteredHotels.map((hotels) => {
                            const {id,
                              icon,
                              hotel,
                              location,
                              stars,
                              amount,
                        
                          refundable} = hotels;
                          return (
                            <Row className='gap-2 mb-4 mb-md-2' key={id}>
                              <Col className=' ' md={8} style={{background:'#fafafa'}} >

                               <Row className='gap-0 gap-xl-2 gap-sm-4'>
                              
                                <Col xs={12} sm={4} className='p-0 m-0'>
                                <img src={icon} className='hotel-image'  />
                                </Col>
                                <Col>
                                <div className='py-2 ps-0 ps-xxl-0  ps-md-5'>
                              <h2 className='hotel-name'>{hotel}</h2>
                              <div className='d-flex mb-2'>
      <img src={star} alt='star'/>    
      <img src={star} alt='star'/>  
      <img src={star} alt='star'/>                      </div>
      <div className='d-flex gap-2 align-items-center mb-2'> <img src={locationGrey} alt='location' style={{height:'25px'}}/> <p className='my-auto'style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>{selectedHotelLocation}</p></div>
      <div className='d-flex gap-3 align-items-center'>  <Button  style={{padding:'5px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
      {stars}/5
      </Button> <p className='refund my-auto'>Read reviews</p></div>
                                </div>
                                </Col>
                               </Row>
                              </Col>
                              <Col className='align-items-center justify-content-center text-center p-2 ' style={{background:'#fafafa'}}>
                              <div className='d-flex justify-content-center'>
                              <p>NGN</p>
     &nbsp;                         <h4>{amount.toLocaleString()}</h4>
                              </div>
                              <p>per night</p>
                              <div className='mb-2'>
                              <Button onClick={() => handleSelectHotel(hotels.id)} style={{height: '35px',
width: '90px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
      Book
      </Button>
                              </div>
                              <p className='refund'> {refundable}</p>
                              </Col>
                            </Row>
                          )
                          })
                        }
                    </div>
                  </div>
                  </Col>
                </Row>
              </div>
            </div>
        </Card.ImgOverlay>
       
        </Card>
        <div  className='d-block d-md-none mb-5 p-3 p-xl-5 p-lg-2 p-md-5 mt-3 mt-md-5 mx-md-4 mx-2 '>
        <div className=''>
              <div className='d-block d-md-none'>
              <div className=' text-center'>
              <Button onClick={handleClear}className=' text-white' style={{width:'200px', border: '2px solid #008080', background:'#008080'}}>Modify</Button>

              </div>
              </div>
              <div className='d-none d-md-block'>
              <div className=' text-center'>
              <Button onClick={handleClear} className=' active text-white' style={{width:'200px', border: '2px solid #008080', background:'none'}}>Modify</Button>

              </div>
              </div>
              
              <div className='mt-5'>
                <Row className=''>
                  <Col xs={12} md={12} lg={4}>
                  <div className='' style={{background:'#fafafa'}}>
                    <div className='d-flex p-3 justify-content-between align-items-center'>
                        <h5>Filter</h5>
                        <p onClick={handleClear}className='forgot-password' >Clear</p>
                        
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3'>
                      <h5>No of stars</h5>
                      <div className='d-flex gap-3 mt-1'>
                        <button className={selectedStarOption === '3 stars' ? 'active-stop' : 'stop'}
          onClick={() => filterHotelsByStar('3 stars')}>3 stars</button>
                        <button className={selectedStarOption === '4 stars' ? 'active-stop' : 'stop'}
          onClick={() => filterHotelsByStar('4 stars')}>4 stars</button>
                        <button className={selectedStarOption === '5 stars' ? 'active-stop' : 'stop'}
          onClick={() => filterHotelsByStar('5 stars')}>5 stars</button>
                      </div>
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3 '>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h5>Price</h5>
                        <p onClick={handleClearAmount}className='forgot-password' >Clear</p>
                        
                    </div>
                    <Form className='d-flex' >
         
                    <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={minAmount}
            onChange={handleMinAmountChange}
          /><Form.Label>{minAmount.toLocaleString()}</Form.Label>
        </Form.Group>
        <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={maxAmount}
            onChange={handleMaxAmountChange}
          />
          <div className='d-flex flex-row-reverse'><Form.Label > {maxAmount.toLocaleString()}</Form.Label></div>
        </Form.Group>
        </Form>
                    </div>
                    <div className='line' style={{width:'100%'}}></div>
                    <div className='p-3'>
                      <h5>Payment type</h5>
                      <div className='mt-4'>
                        <Form>
                        <Form.Group className="mb-2" controlId="formBasicCheckbox">
                        <Form.Check
      type="checkbox"
      id="refundableCheckbox"
      label="Refundable"
      checked={selectedRefundOption === 'refundable'}
        onChange={() => filterRefund('refundable')}
    
    />
    </Form.Group>
    <Form.Group className="" controlId="formBasicCheckbox">
    <Form.Check
      type="checkbox"
      id="nonRefundableCheckbox"
      label="Non-refundable"
      checked={selectedRefundOption === 'nonRefundable'}
      onChange={() => filterRefund('nonRefundable')}
    />
    </Form.Group>
                        </Form>
                      </div>
                    </div>
                   
                  </div>
                  </Col>
                  <Col>
                  <div className='mt-3 mt-lg-0'>
                  <div className='d-block d-sm-flex  p-3 gap-4 align-items-center mb-3'style={{background:'#fafafa'}}>
                        <h5 className=' mb-3 mb-sm-0'>Sort by</h5>
                        <div className='d-block d-sm-flex gap-2'>
                        <button  onClick={filterByAll}
          className={selectedFilter === 'all' ? 'active-filter' : 'filter-button'}> All</button>
                          <button  onClick={filterByCheapest}
          className={selectedFilter === 'cheapest' ? 'active-filter' : 'filter-button'}> Cheapest</button>
                    
                        </div>
                      </div>
                    <div className=''>
                        {
                          filteredHotels.map((hotels) => {
                            const {id,
                              icon,
                              hotel,
                              location,
                              stars,
                              amount,
                        
                          refundable} = hotels;
                          return (
                            <Row className='gap-2 mb-4 mb-md-2' key={id}>
                              <Col className=' ' md={8} style={{background:'#fafafa'}} >

                               <Row className='gap-0 gap-xl-2 gap-sm-4'>
                              
                                <Col xs={12} sm={4} className='p-0 m-0'>
                                <img src={icon} className='hotel-image'  />
                                </Col>
                                <Col>
                                <div className='py-2 ps-0 ps-xxl-0  ps-md-5'>
                              <h2 className='hotel-name'>{hotel}</h2>
                              <div className='d-flex mb-2'>
      <img src={star} alt='star'/>    
      <img src={star} alt='star'/>  
      <img src={star} alt='star'/>                      </div>
      <div className='d-flex gap-2 align-items-center mb-2'> <img src={locationGrey} alt='location' style={{height:'25px'}}/> <p className='my-auto'style={{color:'#626F6F', fontSize:'16px', fontWeight:'500'}}>{selectedHotelLocation}</p></div>
      <div className='d-flex gap-3 align-items-center'>  <Button  style={{padding:'5px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
      {stars}/5
      </Button> <p className='refund my-auto'>Read reviews</p></div>
                                </div>
                                </Col>
                               </Row>
                              </Col>
                              <Col className='align-items-center justify-content-center text-center p-2 ' style={{background:'#fafafa'}}>
                              <div className='d-flex justify-content-center'>
                              <p>NGN</p>
     &nbsp;                         <h4>{amount.toLocaleString()}</h4>
                              </div>
                              <p>per night</p>
                              <div className='mb-2'>
                              <Button onClick={() => handleSelectHotel(hotels.id)} style={{height: '35px',
width: '90px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
      Book
      </Button>
                              </div>
                              <p className='refund'> {refundable}</p>
                              </Col>
                            </Row>
                          )
                          })
                        }
                    </div>
                  </div>
                  </Col>
                </Row>
              </div>
            </div>
        </div>
       
  </div>
  )
}

export default HotelSearch
